import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
} from "@/shared/components/common/Select";
import staticData from "@/public/data/flight/passengers.json";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import {Plus} from "@phosphor-icons/react/dist/ssr";
import {useFormContext} from "react-hook-form";
import type {PassengersSchemaType} from "@/shared/schemas/flight/passengersSchema";
import {defaultPassengerData} from "../../components/defaultFormData";

interface PassengerCardFooterProps {
    priceDetails: PriceDetails;
    isForeign: boolean;
    canAddInfant: boolean;
}

export default function PassengerCardFooter({
                                                priceDetails,
                                                isForeign,
                                                canAddInfant
                                            }: PassengerCardFooterProps) {
    const {addNewPassenger} = staticData.forms.passengersForm;
    const {setValue, getValues} = useFormContext<PassengersSchemaType>();
    const passengerOptions = canAddInfant
        ? addNewPassenger.options.filter(option => option.value === "infant")
        : addNewPassenger.options;
    return (
        <Flex className="md:justify-end px-6">
            <Select
                value=""
                onValueChange={(value) => {
                    setValue("passengers", [
                        ...getValues("passengers"),
                        defaultPassengerData(
                            value as "adult" | "child" | "infant",
                            priceDetails[value as "adult" | "child" | "infant"].payable,
                            isForeign,
                        ),
                    ]);
                }}
            >
                <SelectTrigger
                    className="md:w-[280px]! rounded-xs bg-primary! hover:shadow-2 transition duration-75 ease-linear">
                    <Flex className="w-full gap-x-2 justify-center items-center text-center">
                        <Plus className="w-5 h-5 text-background dark:text-foreground"/>
                        <Typography className="text-background dark:text-foreground">
                            {addNewPassenger.title}
                        </Typography>
                    </Flex>
                </SelectTrigger>
                <SelectContent className="md:w-[280px]! rounded-xs">
                    {passengerOptions.map(({title, desc, value}) => (
                        <SelectItem
                            className="md:w-[280px]! !px-0 rounded-none! text-muted-foreground cursor-pointer hover:bg-muted dark:hover:bg-muted/10"
                            value={value}
                            key={value}
                        >
                            <Flex className="md:w-[280px]! items-center justify-between px-4 gap-x-2">
                                <Flex className="items-center gap-x-1 text-foreground">
                                    <Typography>{addNewPassenger.currency}</Typography>
                                    <Typography>
                                        {priceDetails[
                                            value as "adult" | "child" | "infant"
                                            ].payable.toLocaleString()}{" "}
                                    </Typography>
                                </Flex>

                                <Flex className="space-x-1 text-foreground">
                                    <Typography>({desc})</Typography>
                                    <Typography className="">{title}</Typography>
                                </Flex>
                            </Flex>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </Flex>
    );
}
